import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-multi-lang";

import Modal from "../../../components/Modal/Modal";
import { Col, Button } from "react-bootstrap";
import { InputField, SelectField } from "../../../components/FormElements/FormElements";
import ClientApi from "../../../services/api/clients";
import { toast } from "react-toastify";

interface IProps {
  isOpen: boolean;
  toggle: () => void;
  client_id: number;
  year: number;
  quarter: string;
}

export default function ForceStageModel({
  isOpen,
  toggle,
  client_id,
  year,
  quarter,
}: IProps) {
  const t = useTranslation();
  const dispatch = useDispatch();
  const api = new ClientApi();

  const [loading, setLoading] = useState(false);

  const [inputValue, setInputValue] = useState("");
  const [selectedYear, setSelectedYear] = useState<number | null>(2025);
  const [selectedQuarter, setSelectedQuarter] = useState<string | null>(null);

  useEffect(() => {
    if (isOpen) {
      setSelectedYear(year || null);
      setSelectedQuarter(quarter || null);
    }
  }, [isOpen]);

  const handleUpdate = async () => {
    if (!selectedYear || !selectedQuarter) return;

    try {
      setLoading(true);

      const response = await api.clients().setForceStage({
        client_id: client_id,
        stageId: Number(inputValue),
        year: selectedYear,
        quarter: selectedQuarter,
      });

  
     if (response?.status === 200 && response.data?.success) {
            toast.success(response.data.message);
          
          
            toggle();
          
          
          }

    else{
    
          toast.error(response?.data?.message || t("unexpected_error"));
    }


    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={isOpen} toggle={toggle}>
      
    
      <h4 className="mb-4">
        {t(" Set Force Stage")} 
      </h4>
  <h4 className="mb-4">
        {selectedYear}/{selectedQuarter} 
      </h4>
      <div className="row g-3">

        <Col md={4}>
          <InputField
            value={inputValue}
            onChange={(e: any) => setInputValue(e.target.value)}
            placeholder={t("enter Force Stage")}
          />
        </Col>




      </div>


      <div className="d-flex justify-content-end mt-4">
        <Button
          variant="primary"
          onClick={handleUpdate}
          disabled={loading}
        >
          {loading ? t("saving") : t("save")}
        </Button>
      </div>

    </Modal>
  );
}
